import {Base} from "@/api/Base"

export class MpfDelete extends Base {
    path = "mpf/delete"
}